<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize"> {{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


        <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        
                    <div class="col-md-8 mb-5">


                        <!-- CardDest -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabContent" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Content')"
                                            aria-expanded="false" 
                                            aria-controls="collapseContente" 
                                            data-toggle="collapse"
                                            data-target="#collapseContent">Content
                                            <span id="iconToggleContent" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseContent" 
                                        class="collapse show" 
                                        aria-labelledby="TabContent" 
                                        data-parent="#accordion">

                                <div class="col-12 pt-3">
                                    
                                    <!-- Slug -->
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label for="input0">Slug</label>
                                            <input class="form-control" 
                                                    id="input0" 
                                                    type="text" 
                                                    v-model="row.slug">
                                        </div>
                                    </div>
                                    <!-- End Slug -->

                                    <!-- Title -->
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label for="input1">Title</label>
                                            <input class="form-control" 
                                                    id="input1" 
                                                    type="text" 
                                                    v-model="row.title">
                                        </div>
                                    </div>
                                    <!-- End Title -->

                                  <!-- Body1 -->
                                  <div class="form-group">
                                    <label for="inputText1">Body1 <small>(if mails: developer Mail)</small></label>
                                    <editor
                                        id="inputText1"
                                        v-model="row.body1"
                                        :api-key="editor.api_key"
                                        :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                    />
                                  </div>
                                  <!-- End Body1 -->

                                  <!-- Body2 -->
                                  <div class="form-group">
                                    <label for="inputText2">Body2 <small>(if mails: marketing Mails)</small></label>
                                    <editor
                                        id="inputText2"
                                        v-model="row.body2"
                                        :api-key="editor.api_key"
                                        :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                    />
                                  </div>
                                  <!-- End Body2 -->

                                  <!-- Body3 -->
                                  <div class="form-group">
                                    <label for="inputText3">Body3 <small>(if mails: ERP Mails)</small></label>
                                    <editor
                                        id="inputText3"
                                        v-model="row.body3"
                                        :api-key="editor.api_key"
                                        :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                    />
                                  </div>
                                  <!-- End Body3 -->

                                  <!-- Body4 -->
                                  <div class="form-group">
                                    <label for="inputText4">Body4 <small>(if mails: Destination Mail)</small></label>
                                    <editor
                                        id="inputText4"
                                        v-model="row.body4"
                                        :api-key="editor.api_key"
                                        :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                    />
                                  </div>
                                  <!-- End Body4 -->

                                  <!-- Body5 -->
                                  <div class="form-group">
                                    <label for="inputText5">Body5 <small>(if mails: Saudi Destination Mail)</small></label>
                                    <editor
                                        id="inputText5"
                                        v-model="row.body5"
                                        :api-key="editor.api_key"
                                        :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                    />
                                  </div>
                                  <!-- End Body5 -->

                                  <!-- Body6 -->
                                  <div class="form-group">
                                    <label for="inputText6">Body6 <small>(if mails: Indonesia Destination Mail)</small></label>
                                    <editor
                                        id="inputText6"
                                        v-model="row.body6"
                                        :api-key="editor.api_key"
                                        :init="{
                                                  height: 300,
                                                  menubar: editor.menubar,
                                                  plugins: editor.plugins,
                                                  external_plugins: editor.external_plugins,
                                                  toolbar: editor.toolbar
                                              }"
                                    />
                                  </div>
                                  <!-- End Body6 -->

                                  <!-- Body7 -->
                                  <div class="form-group">
                                    <label for="inputText7">Body7</label>
                                    <editor
                                        id="inputText7"
                                        v-model="row.body7"
                                        :api-key="editor.api_key"
                                        :init="{
                                                  height: 300,
                                                  menubar: editor.menubar,
                                                  plugins: editor.plugins,
                                                  external_plugins: editor.external_plugins,
                                                  toolbar: editor.toolbar
                                              }"
                                    />
                                  </div>
                                  <!-- End Body7 -->

                                  <!-- Body8 -->
                                  <div class="form-group">
                                    <label for="inputText8">Body8</label>
                                    <editor
                                        id="inputText8"
                                        v-model="row.body8"
                                        :api-key="editor.api_key"
                                        :init="{
                                                  height: 300,
                                                  menubar: editor.menubar,
                                                  plugins: editor.plugins,
                                                  external_plugins: editor.external_plugins,
                                                  toolbar: editor.toolbar
                                              }"
                                    />
                                  </div>
                                  <!-- End Body8 -->

                                  <!-- Body9 -->
                                  <div class="form-group">
                                    <label for="inputText9">Body9</label>
                                    <editor
                                        id="inputText9"
                                        v-model="row.body9"
                                        :api-key="editor.api_key"
                                        :init="{
                                                  height: 300,
                                                  menubar: editor.menubar,
                                                  plugins: editor.plugins,
                                                  external_plugins: editor.external_plugins,
                                                  toolbar: editor.toolbar
                                              }"
                                    />
                                  </div>
                                  <!-- End Body9 -->

                                  <!-- Body10 -->
                                  <div class="form-group">
                                    <label for="inputText10">Body10</label>
                                    <editor
                                        id="inputText10"
                                        v-model="row.body10"
                                        :api-key="editor.api_key"
                                        :init="{
                                                  height: 300,
                                                  menubar: editor.menubar,
                                                  plugins: editor.plugins,
                                                  external_plugins: editor.external_plugins,
                                                  toolbar: editor.toolbar
                                              }"
                                    />
                                  </div>
                                  <!-- End Body10 -->

                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End CardDest -->


                </div>





                    <!-- ******* SideNavbar ******** -->
                    <div class="col-md-4 mb-5">

                        <!-- Nav Language -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavLanguage" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Language')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavLanguage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavLanguage">Language
                                            <span id="iconToggleLanguage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavLanguage" 
                                        class="collapse" 
                                        aria-labelledby="NavLanguage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <!-- Language -->
                                        <div class="form-group">
                                            <div v-if="languageLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!languageLoading" 
                                                    v-model="row.language_id">
                                                    <option value="">Select Language</option>
                                                    <option v-for="(language, index) in languages" 
                                                            :key="index"
                                                            :value="language.id">
                                                            {{ language.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <!-- End Language -->
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Language -->
                        <!-- NavTwo -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('Image')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavImage">Featued Image
                                            <span id="iconToggleImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavImage" 
                                        class="collapse" 
                                        aria-labelledby="NavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img v-if="row.image_preview" 
                                                    :src="row.image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onImageChange"
                                                    accept="image/*">
                                            </div>
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                            </div>
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_title">
                                            </div>
                                            <!-- Image -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End NavTwo -->

                        <!-- Nav Multiple links -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavMultipleLinks" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('MultipleLinks')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavMultipleLinks" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavMultipleLinks">
                                            Multiple Links
                                            <span id="iconToggleMultipleLinks" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavMultipleLinks" 
                                        class="collapse" 
                                        aria-labelledby="NavMultipleLinks" 
                                        data-parent="#accordionNav">
                                        
                                        <div class="col-12 pt-3">
                                            <div class="form-group">
                                                <div v-if="linksLoading" class="text-center">
                                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                                        role="status" 
                                                        aria-hidden="true">
                                                    </span>
                                                </div>
                                                <multiselect v-if="!linksLoading"
                                                        id="multiselect"
                                                        ref="multiselectRef"
                                                        autocomplete="on"
                                                        v-model="row.linksValues" 
                                                        :options="linksOptions" 
                                                        :multiple="true"
                                                        :close-on-select="false" 
                                                        :clear-on-select="false" 
                                                        :hide-selected="true" 
                                                        :preserve-search="true" 
                                                        :taggable="false"
                                                        placeholder="Type to search links"
                                                        :preselect-first="false">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Multiple Links -->
                        
                        <!-- NavThree -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavStatus" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Status')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavStatus" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavStatus">Status & Visibility
                                            <span id="iconToggleStatus" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Status -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch1" 
                                                        :checked="row.status"
                                                        @click="onStatus">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch1"
                                                        v-html="(row.status) ? 'Active' : 'Inactive'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End Status -->


                                            <!-- View in Footer -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch7" 
                                                        :checked="row.view_in_footer"
                                                        @click="onViewInFooter">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch7"
                                                        v-html="(row.view_in_footer) 
                                                            ? 'Show In Footer' 
                                                            : 'Hide In Footer'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in Footer -->

                                            <!-- Sort -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: inputDisplay}"
                                                            placeholder="Sort In Footer" 
                                                            id="inputText8" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.sort">
                                                </div>
                                            </div>
                                            <!-- End Sort -->

                                            <!-- Is Subscribe -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch8" 
                                                        :checked="row.is_subscribe"
                                                        @click="onIsSubscribe">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch8"
                                                        v-html="(row.is_subscribe) 
                                                            ? 'Is Subscribe' 
                                                            : 'Not Subscribe'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End is Subscribe -->

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End NavThree -->

                        </div>
                    </div>
                </div>
                <!-- End Content -->

                    

                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading"> Create Setting</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger" 
                                :disabled="btnLoading" 
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>


                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    import Multiselect from 'vue-multiselect';

    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Editor,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // row
                    slug: '',
                    title: '',
                    body1: '',
                    body2: '',
                    body3: '',
                    body4: '',
                    body5: '',
                    body6: '',
                    body7: '',
                    body8: '',
                    body9: '',
                    body10: '',

                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // status & visiblity
                    status: 1,
                    view_in_footer: 0,
                    is_subscribe: 0,
                    sort: '',

                    // multiple links
                    linksValues: [],
                    //language
                    language_id:'',
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                pgLoading: false,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'settings',

                // multiple links
                linksOptions: [],
                linksLoading: true,

                inputDisplay: 'none',

                // language
                languages: [],
                languageLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }
            this.fetchLanguages();

        },
        methods: {

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },
            // fetchMultipleLinks
            fetchMultipleLinks(){
                this.linksLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/links',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.linksLoading = false;
                    this.linksOptions = res.data.links;

                    this.fetchMultipleHotels(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // Add New
            addNew(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {
                    if (this.row.status == false) {
                        this.row.status = 0;
                    } else {
                        this.row.status = 1;
                    }
                    if (this.row.view_in_footer == false) {
                        this.row.view_in_footer = 0;
                    } else {
                        this.row.view_in_footer = 1;
                    }
                    if (this.row.is_subscribe == false) {
                        this.row.is_subscribe = 0;
                    } else {
                        this.row.is_subscribe = 1;
                    }

                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };
                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs,
                        method: 'POST',
                        data: {
                            tenant_id: this.tenant_id,
                            // row
                            slug: this.row.slug,
                            title: this.row.title,
                            body1: this.row.body1,
                            body2: this.row.body2,
                            body3: this.row.body3,
                            body4: this.row.body4,
                            body5: this.row.body5,
                            body6: this.row.body6,
                            body7: this.row.body7,
                            body8: this.row.body8,
                            body9: this.row.body9,
                            body10: this.row.body10,

                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // status & visibility
                            status: this.row.status,
                            view_in_footer: this.row.view_in_footer,
                            is_subscribe: this.row.is_subscribe,
                            sort: this.row.sort,
                            links: this.row.linksValues,

                            //language
                            language_id: this.row.language_id,
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Added Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: err.response.data.message
                                });
                            }
                        })
                        .finally(() => {})
                }
            },


            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // view in Footer
            onViewInFooter(){
                if(this.row.view_in_footer) {
                    this.row.view_in_footer = 0;
                    this.inputDisplay = 'none';
                }
                else {
                    this.row.view_in_footer = 1;
                    this.inputDisplay = 'block';
                }
            }, 
            
            // is subscribe
            onIsSubscribe(){
                if(this.row.is_subscribe)
                    this.row.is_subscribe = 0;
                else
                    this.row.is_subscribe = 1;
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                if (div == 'MultipleLinks') {
                    this.fetchMultipleLinks();
                }
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
